import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from './svg/SvgIcon';

const Dashboard = ({ color, props }) => (
  /* eslint-disable max-len */
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path
      fill={color || '#C4C8CE'}
      d="M16 2.594l-.72.687-13 13 1.44 1.44L5 16.437V28h9V18h4v10h9V16.437l1.28 1.282 1.44-1.44-13-13-.72-.686zm0 2.844l9 9V26h-5V16h-8v10H7V14.437l9-9z"
    />
  </SvgIcon>
  /* eslint-enable max-len */
);

export default pure(Dashboard);
